import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Spinner100 } from "../../components/icons/SvgIcons";
import { snLogoBlanco as snLogo, snImagenFondo as snFondo } from '../../utils/icons';
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { login } from "../../redux/actions";
import { EyeIcon, EyeOffIcon } from "../../components/icons/SvgIcons";

function Landing() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    clearErrors("dni");
  };

  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    data.contrasena = password.trim();

    try {
      const response = await dispatch(login(data));
      if (response.message) {
        setError("dni", {
          type: "server",
          message: response.message || "Error desconocido",
        });
      } else {
        navigate("/inicio");
      }
    } catch (error) {
      setError("dni", {
        type: "server",
        message: "No se pudo conectar con el servidor. Intentá de nuevo más tarde, o comunicate con soporte.",
      });
    }

    setLoading(false);
  };

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <div className="w-full h-screen  flex flex-col justify-start items-center gap-[6rem]">
      {/* Encabezado */}
      <div className="w-full h-[5rem]  py-[1rem] bg-[#0477ad] shadow flex items-center">
        <div className="relative w-full h-full justify-start items-center flex">
          <img
            src={snLogo}
            alt="Logo San Nicolas"
            className="w-[3rem] ml-[1.5rem]"
          />
          <div className=" w-[39px] border border-[#f6f5f5]  rotate-90" />
          <div className=" text-[#f6f5f5] text-sm font-normal font-inter">
            Corralón San Nicolás
          </div>
        </div>
      </div>

      <img
        src={snFondo}
        alt=""
        className="absolute w-full h-full object-cover top-0 left-0 -z-10"
      />

      {/* Contenedor principal */}
      <div className="sm:w-full max-w-[22rem] mx-5 sm:px-6 px-8 py-3 bg-white rounded-lg shadow flex flex-col justify-center items-center ">
        <div className="py-5 flex flex-col justify-center items-center gap-7 sm:w-[18rem]">
          {/* Título */}
          <div className="text-[#3d4245] text-xl font-bold font-inter text start w-full">
            Inicio de sesión
          </div>

          {/* Formulario */}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col justify-start items-start gap-5">
              {/* Campo DNI */}
              <div className=" flex flex-col justify-start items-start gap-1">
                <label className="text-[#3d4245] text-sm font-normal font-inter">
                  DNI
                </label>

                <input
                  name="dni"
                  type="text"
                  placeholder="0000000000000"
                  className="sm:w-[18rem] w-[14rem] text-sm font-normal font-inter outline-none rounded-md"
                  {...register("dni", {
                    required: "Ingrese el número de DNI por favor",
                    validate: (value) => {
                      const cleanedValue = value.replace(/\s+/g, ""); // Elimina todos los espacios

                      if (!/^\d+$/.test(cleanedValue)) {
                        return "El DNI solo puede contener números.";
                      }

                      if (cleanedValue.length < 6 || cleanedValue.length > 9) {
                        return "El DNI debe tener entre 6 y 9 dígitos.";
                      }

                      return true;
                    },
                    setValueAs: (value) => value?.replace(/\s+/g, ""), // Eliminar espacios innecesarios
                  })}
                />
              </div>

              {/* Campo Contraseña */}
              <div className=" flex flex-col justify-start items-start gap-1">
                <label className="text-[#3d4245] text-sm font-normal font-inter">
                  Contraseña
                </label>
                <div className="relative sm:w-[18rem] w-[14rem] ">
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    placeholder="Contraseña"
                    className="w-full text-sm font-normal font-inter outline-none rounded-md pl-4 pr-10 py-2 "
                    value={password}
                    onChange={handlePasswordChange}
                    onBlur={() => {
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSubmit(onSubmit)();
                      }
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    {isPasswordVisible ? (
                      // Ícono para ocultar contraseña
                      <EyeOffIcon className="w-5 h-5"/>
                    ) : (
                      // Ícono para mostrar contraseña
                      <EyeIcon className="w-5 h-5"/>
                    )}
                  </button>
                </div>
              </div>

              {/* Botón */}
              <button
                type="submit"
                className="w-full mt-1 py-[9px] bg-[#0477ad] rounded-lg flex justify-center items-center"
                disabled={loading}
              >
                {loading ? (
                  <Spinner100 className="w-6 h-6 animate-spin text-[#0477ad] fill-white"/>
                ) : (
                  <span className="text-[#f6f5f5] text-sm font-semibold font-inter">
                    Iniciar sesión
                  </span>
                )}
              </button>
            </div>
          </form>
          <div className="gap-0  justify-center items-center text-center">
            {Object.values(errors).map((error, index) => (
              <p className="text-red-500" key={index}>
                {error.message}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
